/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CassiereCreationForm } from '../model/models';
import { CassiereDTO } from '../model/models';
import { CassiereNegoziReplaceForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NegozioCreationForm } from '../model/models';
import { NegozioDTO } from '../model/models';
import { NegozioPatchForm } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelCassiereDTO } from '../model/models';
import { PagedModelNegozioDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AssegnaNegoziCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
    cassiereNegoziReplaceForm: CassiereNegoziReplaceForm;
}

export interface CreaCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    cassiereCreationForm: CassiereCreationForm;
}

export interface CreaNegozioEsercenteBackofficeRequestParams {
    profiloId: string;
    negozioCreationForm: NegozioCreationForm;
}

export interface DeleteCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
}

export interface DeleteNegozioEsercenteBackofficeRequestParams {
    profiloId: string;
    idNegozio: string;
}

export interface GetCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
}

export interface GetNegozioEsercenteBackofficeRequestParams {
    profiloId: string;
    idNegozio: string;
}

export interface ListCassieriEsercenteBackofficeRequestParams {
    profiloId: string;
    pageable: Pageable;
}

export interface ListNegoziEsercenteBackofficeRequestParams {
    profiloId: string;
    pageable: Pageable;
}

export interface PatchEnableCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
    enable: boolean;
}

export interface PatchNegozioCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
    idNegozio: string;
    aggiungi: boolean;
}

export interface ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams {
    profiloId: string;
    idCassiere: string;
}

export interface UpdateNegozioEsercenteBackofficeRequestParams {
    profiloId: string;
    idNegozio: string;
    negozioPatchForm: NegozioPatchForm;
}


export interface EsercentiNegoziECassieriBackofficeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Sostituisce l\&#39;insieme dei negozi di un cassiere.
     * Replace dell\&#39;intero insieme; insieme vuoto → 422. Ogni negozio deve appartenere all\&#39;esercente (404 altrimenti). 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/negozi
* @param requestParameters
     */
    assegnaNegoziCassiereEsercenteBackoffice(requestParameters: AssegnaNegoziCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Crea un cassiere per conto dell\&#39;esercente (onboarding via email).
     * Come il self-service con il titolare come caller logico: email &#x3D;&#x3D; quella del titolare → aggiunge al titolare l\&#39;authority CASSIERE; email di un altro utente → 422 (anti-escalation); email nuova → account inerte + mail di attivazione. L\&#39;assegnazione ai negozi e\&#39; un asse separato. 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri
* @param requestParameters
     */
    creaCassiereEsercenteBackoffice(requestParameters: CreaCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Crea un punto vendita per conto dell\&#39;esercente.
     * Come il self-service: nome/indirizzo obbligatori, normalizzati uppercase+trim. 404 se l\&#39;esercente e\&#39; fuori perimetro; 422 se nome/indirizzo blank o esercente bloccato dall\&#39;amministrazione (esercente_bloccato).
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/negozi
* @param requestParameters
     */
    creaNegozioEsercenteBackoffice(requestParameters: CreaNegozioEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

    /**
     * Rimuove un cassiere (l\&#39;account resta).
     * Rimuove l\&#39;authority CASSIERE e le assegnazioni ai negozi e revoca le sessioni, senza cancellare lo User. Il titolare non puo\&#39; rimuovere se stesso come cassiere.
     * @endpoint delete /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}
* @param requestParameters
     */
    deleteCassiereEsercenteBackoffice(requestParameters: DeleteCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Elimina un punto vendita di un esercente.
     * Stesse regole del self-service (il cascade rimuove le assegnazioni cassiere; gli account restano).
     * @endpoint delete /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
* @param requestParameters
     */
    deleteNegozioEsercenteBackoffice(requestParameters: DeleteNegozioEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un cassiere di un esercente.
     * 404 se l\&#39;esercente e\&#39; fuori perimetro o il cassiere e\&#39; di un\&#39;altra impresa.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}
* @param requestParameters
     */
    getCassiereEsercenteBackoffice(requestParameters: GetCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Dettaglio di un punto vendita di un esercente.
     * 404 se l\&#39;esercente e\&#39; fuori perimetro o il negozio e\&#39; di un\&#39;altra impresa.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
* @param requestParameters
     */
    getNegozioEsercenteBackoffice(requestParameters: GetNegozioEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

    /**
     * Elenca i cassieri di un esercente.
     * Page dei cassieri assegnati a negozi del profilo; il titolare non compare nella lista.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri
* @param requestParameters
     */
    listCassieriEsercenteBackoffice(requestParameters: ListCassieriEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelCassiereDTO>;

    /**
     * Elenca i punti vendita di un esercente.
     * Page dei negozi del profilo (Pageable standard, sort di default per nome).
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/negozi
* @param requestParameters
     */
    listNegoziEsercenteBackoffice(requestParameters: ListNegoziEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelNegozioDTO>;

    /**
     * Sospende/riabilita un cassiere.
     * ?enable&#x3D;false sospende (revoca le sessioni), ?enable&#x3D;true riabilita. Il titolare non puo\&#39; sospendere se stesso come cassiere. Un cassiere bloccato dall\&#39;amministrazione non si riabilita da qui. ?enable&#x3D;true su un titolare bloccato dall\&#39;amministrazione: 422 esercente_bloccato.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/enable
* @param requestParameters
     */
    patchEnableCassiereEsercenteBackoffice(requestParameters: PatchEnableCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Aggiunge/rimuove un singolo negozio dallo scope del cassiere.
     * ?aggiungi&#x3D;true aggiunge (no-op idempotente se gia\&#39; presente; 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione), false rimuove la coppia.
     * @endpoint patch /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/negozi/{id_negozio}
* @param requestParameters
     */
    patchNegozioCassiereEsercenteBackoffice(requestParameters: PatchNegozioCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<CassiereDTO>;

    /**
     * Reinvia l\&#39;email di attivazione a un cassiere.
     * Solo se l\&#39;account del cassiere non e\&#39; ancora attivato; gia\&#39; attivo o sospeso → 422. Il cassiere deve avere almeno un negozio dell\&#39;esercente (404 altrimenti).
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/reinvia-attivazione
* @param requestParameters
     */
    reinviaAttivazioneCassiereEsercenteBackoffice(requestParameters: ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica un punto vendita di un esercente.
     * PUT-replace di nome/indirizzo con optimistic lock (409 su version stale). 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
* @param requestParameters
     */
    updateNegozioEsercenteBackoffice(requestParameters: UpdateNegozioEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

}
